(/** @param {JQueryStatic} $ */ function ($) {
    var megashop = window.megashop;
    var megashop_easyreviews = megashop.easyreviews = megashop.easyreviews || {};

    var Update = megashop.Update;

    var ComponentRegistry = megashop.ComponentRegistry;

    var ModalUtil = megashop.ModalUtil;

    var LazyLoad = megashop.LazyLoad;

    var EasyReviews = megashop_easyreviews.EasyReviews = ComponentRegistry.register(function ($context) {
        return $context.select('.easyreviews');
    }, function ($easyreviews) {
        var _private = {
            lazy_load: null,
            initEventListeners: function () {
                $easyreviews.on('click', '.easyreviews__more-button', function () {
                    $easyreviews.addClass('easyreviews_lazy-load');
                    _private.lazy_load.watch();
                });

                $easyreviews.on('loading@megashop:lazy-load', function () {
                    $easyreviews.addClass('easyreviews_loading');
                });

                $easyreviews.on('loaded@megashop:lazy-load', function (e, response) {
                    var message = megashop.config.language['page_number'].replace(/(.+)%page%(.+)%pages_count%/, '$1'+ _private.lazy_load.getPage()+'$2'+_private.lazy_load.getCountPages());

                    $easyreviews.removeClass('easyreviews_loading');
                    $easyreviews.find('.easyreviews__list')
                        .append(megashop.PageSeparatorBuilder.create(message))
                        .append($(response).find('.easyreviews__review'));
                    $easyreviews.find('.easyreviews__pagination-container')
                        .replaceWith($(response).find('.easyreviews__pagination-container'));

                    Update($easyreviews);
                });

                $easyreviews.on('error@megashop:lazy-load', function () {
                    $easyreviews.removeClass('easyreviews_loading');
                });

                $easyreviews.on('done@megashop:lazy-load', function () {
                    $easyreviews.addClass('easyreviews_lazy-load-done');
                });
            },
            init: function () {
                var $reviewsReviews = $easyreviews.find('.easyreviews__reviews');

                if ($reviewsReviews.length > 0) {
                    _private.lazy_load = LazyLoad($reviewsReviews)
                }

                let $detailedRating = $easyreviews.find('.easyreviews__detailed-rating');

                if ($detailedRating.length > 0) {
                    let items = $detailedRating.find('.easyreviews-progress span');

                    for (let i = 0; i < items.length; i++) {
                        let progress = $(items[i]).data('progress');
                        $(items[i]).css('width', progress + '%');
                    }
                }
            }
        }

        _private.init();
        _private.initEventListeners();
    });

    var OpenFormButton = megashop_easyreviews.OpenFormButton = ComponentRegistry.register(function ($context) {
        return $context.select('.easyreviews-open-form');
    }, function ($button, self) {
        var $reviewForm = $('input[name="easyreview_review_form"]').first().val();

        $.extend(self, {
            initEventListeners: function () {
                $button.on('click', function () {
                    ModalUtil.openContent($reviewForm, {
                        title: megashop.config.language['write_a_review'],
                        classes: 'easyreviews-popup',
                        contentClasses: 'easyreviews-popup__content'
                    });
                });
            }
        });

        self.initEventListeners();
    });

    var EasyreviewsForm = megashop_easyreviews.EasyreviewsForm = ComponentRegistry.register(function ($context) {
        return $context.select('.easyreviews-form');
    }, function ($form, self) {
        $.extend(self, {
            initEventListeners: function () {
                $form.on('submit', function () {
                    $form.find('.easyreviews-form__error-container').remove();
                });

                $form.on('success@megashop:ajax-form', function (e, response) {
                    var _response = response;
                    if (typeof _response !== 'object') {
                        var JSONResponse = JSON.parse(response);

                        if (JSONResponse['status']) {
                            _response = JSONResponse;
                        }
                    }

                    if (_response.status !== 'ok') {
                        return;
                    }

                    if (response.data.status == "error") {
                        var errors = Object.keys(response.data.errors);
                        if (errors.length > 0) {
                            errors.forEach(function(element) {
                                var $errorField = $form.find('.easyreviews-form__field[data-field_id="'+element+'"]');
                                var $errorContainer = $errorField.find('.easyreviews-form__error-container');

                                if ($errorContainer.length === 0) {
                                    $errorContainer = $('<div class="easyreviews-form__error-container"></div>');
                                    $errorField.find('.form-field__value').append($errorContainer);
                                }

                                var errorText = response.data.errors[element];

                                $errorContainer.html(errorText);
                            });
                        }
                    } else {
                        var $addReviewForm = $(e.target);
                        var isModerate = $addReviewForm.find('input[name="moderate"]').length > 0;

                        if (isModerate) {
                            $form.find('form').remove();
                            $form.find('.easyreviews-form__notice').show();
                        } else {
                            $form.trigger('review_added', _response.data);
                            ModalUtil.close();
                        }
                    }
                });
            }
        });

        self.initEventListeners();
    });

})(jQuery);
